// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"e70386bd","160":"8615b226","173":"d5c1b029","217":"d363d766","444":"6daeb7dc","465":"3ce7f551","578":"18dac281","668":"3757a7f7","715":"6f4ae202","754":"467d26ad","758":"4be07011","872":"5db98e5b"}[chunkId] + ".chunk.js";
};